import { render, staticRenderFns } from "./disputes-table-v2.vue?vue&type=template&id=76cc36dc"
import script from "./disputes-table-v2.vue?vue&type=script&lang=js"
export * from "./disputes-table-v2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports